// extracted by mini-css-extract-plugin
export default {"tags":"Slideover_tags__r-Y18","deleteButton":"Slideover_deleteButton__9Sjrs"};